import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var query_pagination_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M4 13.5h6v-3H4v3zm8 0h3v-3h-3v3zm5-3v3h3v-3h-3z" }) });
export {
  query_pagination_default as default
};
//# sourceMappingURL=query-pagination.js.map
